import {
	createStyles,
	makeStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => {
	return createStyles({
		sectionSummaryInsuredInfo_container: {

		},
		sectionSummaryInsuredInfo_mailingAddressContainer: {
			paddingBottom: theme.spacing(2),
		},
		sectionSummaryInsuredInfo_mailingAddressLine: {
			padding: theme.spacing(.5, 0),
			color: theme.palette.info.main,
		},
	});
});

export default useStyles;
